<template>
  <div>
    <navBar />
    <div class="conversion-container main-container">
      <div class="bg-container">
        <img src="@/assets/images/solution/conversion-bg.png">
        <p>解决方案</p>
      </div>
      <h1>销售线索管理与转化解决方案</h1>
      <span class="line"></span>
      <div class="industry">
        <img src="@/assets/images/solution/conversion-logo.png">
        <div class="info">
          <h2>行业特点：</h2>
          <p>
          耐用消费品，消费决策周期长，销售过程干扰因素复杂，销售线索转化率低，营销素材更新慢，线索跟进不可控，客户认知不全面，70%的时间都会在基础了解沟通上。销售过程信息与数据不透明。
          </p>
        </div>
      </div>
      <div class="step">
        <div class="info">
          <h2>解决问题：</h2>
          <p><span>•</span>更高效的线索管理：销售线索第一时间响应，杜绝N天的才联系，导致客户流失。</p>
          <p><span>•</span>线索的智能化分配：如何将线索分给最合适的人跟进，既要结合客户需求，又要考虑销售的能力。</p>
          <p><span>•</span>沟通效率提升：如何让销售更全面了解客户需求，传递更针对性的内容，缩短客户决策周期，提高转化。</p>
          <p><span>•</span>销售过程管理：如何赋能销售做好自我计划管理，提高效率。同时也让上级知道整体进度，不要月前报喜，月底报悲。</p>
          <h2 style="padding-top: 49px">方案创新：</h2>
          <p>
            打破传统，将线索管理与自动化营销与企业微信销售终端进行数据整合，设计全新数字化销售SOP，从线索进入的第一时间就形成全自动流转控制优化分配。利用企业微信，将用户数据全面展现，系统指定沟通任务计划，全过程数据化，方便管理。      
          </p>
        </div>
        <img  src="@/assets/images/solution/conversion-steps.png">
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  components: {
    navBar,
    footerBar
  },
}
</script>
<style lang="scss" scoped>
.conversion-container {
  padding-bottom: 120px;
  .bg-container {
    position: relative;
    overflow: hidden;
    max-width: 1920px;
    min-width: $min-screen-width;
    margin: 0 auto;
    p {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 645px;
    }
  }
  h1 {
    padding-top: 110px;
    padding-bottom: 25px;
    font-size: $font-size-32;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 30px;
    color: #333333;
    text-align: center;
    // letter-spacing: 40px;
  }
  .line {
    display: block;
    width: 60px;
    height: 2px;
    background: #1F71FF;
    margin: 0 auto;
    margin-bottom: 90px;
  }
  .industry {
    width: $min-screen-width;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    padding-bottom: 90px;
    .info {
      text-align: left;
      padding-left: 155px;
      h2 {
        font-size: $font-size-20;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3B3B3B;
        padding-bottom: 36px;
      }
      p {
        font-size: $font-size-18;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 31px;
        color: #707070;
        width: 430px;
      }
    }
    img {
      margin-left: 74px;
    }
  }
  .step {
    width: $min-screen-width;
    display: flex;
    align-items: center;
    margin: 0 auto;
    // margin-bottom: 154px;
    .info {
      width: 500px;
      margin-right: 78px;
      h2 {
        font-size: $font-size-20;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 44px;
        color: #3B3B3B;
        padding-bottom: 29px;
      }
      p {
        font-size: $font-size-18;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 31px;
        color: #707070;
        display: flex;
        span {
          font-size: 15px;
          margin-right: 10px;
        } 
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/solution/conversion.vue